import {
  fetchDocuSignType,
  getDownloadDocURLType,
  getRecipientsByEntityInstanceId,
  previewTemplatePayloadType,
  sendTemplatePayloadDocuSignType,
  sendTemplateV3PayloadType,
  sendTemplateWithEnvelopeIdPayloadType,
} from '../types'
import axiosInstance from '../utils/axiosInstance'
import { resolveEntityName } from '../utils/entities.utils'
import { API_END_POINT } from '../utils/environment'
import {
  buildProgramServiceHeaders,
  validateApiParams,
} from '../utils/functions'

const getSearchedTemplatesinManualCommunicationApi = async (
  page?: number,
  limit?: number,
  filter?: {
    search_key: string
    operator: string
    search_value: number[] | string[] | boolean[]
  }[]
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/communications/advance?page=${page}&size=${limit}`,
    {
      fields: null,
      search_criteria: filter,
    }
  )
}

const getAllServicesinManualCommunicationApi = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}services`)
}

const sendCommunicationTemplateToRecipientApi = async (
  payload: sendTemplateWithEnvelopeIdPayloadType,
  programId?: string,
  serviceId?: string
) => {
  return payload?.envelopeId === ''
    ? await axiosInstance.post(
        `${API_END_POINT.TEMPLATE}/v2/communications/send`,
        payload?.sendPayload,
        {
          headers: buildProgramServiceHeaders(programId, serviceId),
        }
      )
    : await axiosInstance.post(
        `${API_END_POINT.TEMPLATE}/v2/communications/send?envelopeId=${payload?.envelopeId}`,
        payload?.sendPayload,
        {
          headers: buildProgramServiceHeaders(programId, serviceId),
        }
      )
}

const sendCommunicationTemplateToRecipientApiV3 = async (
  payload: sendTemplateV3PayloadType,
  programId?: string,
  serviceId?: string
) => {
  return payload?.envelopeId === ''
    ? await axiosInstance.post(
        `${API_END_POINT.TEMPLATE}/v3/communications/send`,
        payload?.sendPayload,
        {
          headers: buildProgramServiceHeaders(programId, serviceId),
        }
      )
    : await axiosInstance.post(
        `${API_END_POINT.TEMPLATE}/v2/communications/send?envelopeId=${payload?.envelopeId}`,
        payload?.sendPayload,
        {
          headers: buildProgramServiceHeaders(programId, serviceId),
        }
      )
}

const sendCommunicationTemplateToRecipientViaDocuSignApi = async (
  payload: sendTemplatePayloadDocuSignType
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/docusign/send?caseId=${payload?.caseId}&email=${payload.email}&templateId=${payload.templateId}`,
    payload.sendPayload
  )
}

const getDownloadDocURLApi = async (payload: getDownloadDocURLType) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v2/communications/download-url`,
    payload
  )
}

const getPreviewTemplateByCaseidAndTemplateId = async (
  payload: previewTemplatePayloadType,
  programId?: string,
  serviceId?: string
) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/communications/preview?caseId=${payload.caseId}&templateId=${payload.templateId}&editable=${payload?.isEditable}&programId=${payload?.programId}`,
    {
      headers: buildProgramServiceHeaders(programId, serviceId),
    }
  )
}

const fetchAllAttachmentsForATemplateById = async (
  payload: previewTemplatePayloadType
) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/communications/doc-template/preview?caseId=${payload.caseId}&templateId=${payload.templateId}&editable=true`
  )
}
const fetchUrlDocuSign = async (payload: fetchDocuSignType) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/docusign/docusignUrl`,
    payload
  )
}

const getRecipientsCorrespondingToEntityInstance = async (
  payload: getRecipientsByEntityInstanceId
) => {
  const resolvedEntityName = resolveEntityName(
    payload?.apiPayload?.entity_name,
    undefined
  )
  validateApiParams(
    {
      id: payload?.id,
      entity_name: resolvedEntityName,
    },
    {
      endpoint: `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/${resolvedEntityName}/${payload?.id}`,
      method: 'POST',
    }
  )
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/${resolvedEntityName}/${payload?.id}`,
    { ...payload?.apiPayload, entity_name: resolvedEntityName }
  )
}

const getBase64forDocumentPreview = async (
  caseId: number,
  templateId: number
) => {
  return axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/document-template/preview_dynamic_document?documentId=${templateId}&caseId=${caseId}`
  )
}
const getInsuranceOptions = async (caseId: number) => {
  return axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/generic-query/case-insurance-phones?param1=${caseId}`
  )
}

const getAppealInsuranceOptions = async (caseId: number) => {
  return axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/generic-query/appeal-case-insurance-details?param1=${caseId}`
  )
}

const resendCommunicationAPI = async (communicationId: number) => {
  return axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v2/communications/resend/${communicationId}`
  )
}

export {
  getAllServicesinManualCommunicationApi,
  getPreviewTemplateByCaseidAndTemplateId,
  sendCommunicationTemplateToRecipientApi,
  fetchAllAttachmentsForATemplateById,
  sendCommunicationTemplateToRecipientViaDocuSignApi,
  fetchUrlDocuSign,
  getSearchedTemplatesinManualCommunicationApi,
  getDownloadDocURLApi,
  sendCommunicationTemplateToRecipientApiV3,
  getRecipientsCorrespondingToEntityInstance,
  getBase64forDocumentPreview,
  getInsuranceOptions,
  getAppealInsuranceOptions,
  resendCommunicationAPI,
}
